/**
 * @file TopStallSection.jsx
 * @location src/components/layout/notificationbell/TopStallSection.jsx
 * @role NotificationBell 최상단 — 모든 inbox 중 가장 오래된 정체 상위 1~2건 부각
 *   원본 섹션(수령대기/팀원-안 읽음정체)에도 그대로 노출되며, 여기서는 추가 강조 역할.
 *   (검수대기 review 단계 razor ㉓ 폐기 — unack 단계만)
 */
import { useMembers } from '../../../store/useMembers';
import { Icon } from '../../ui/Icon';
import { STAGE_LABEL, StallBadge } from './TaskInboxes';

function buildSub(t, mname) {
  if (t._src === 'sub') return `팀원 ${STAGE_LABEL[t._stage] ?? t._stage} · 담당 ${mname(t.aee)}`;
  return `안 읽음 · 지시 ${mname(t.aor)}`;
}

/**
 * @param {object} props
 * @param {Array} props.topStall
 * @param {() => void} props.onGoToTasks
 */
export function TopStallSection({ topStall, onGoToTasks }) {
  const { mname } = useMembers();
  if (!topStall || topStall.length === 0) return null;

  return (
    <div className="nbell-sec nbell-sec--stall">
      <div className="nbell-sec-title nbell-sec-alert">
        <Icon name="urgent" size={14} /> 최우선 정체 <span className="nbell-sec-cnt">{topStall.length}</span>
      </div>
      {topStall.map(t => (
        <button key={`top-${t._src}-${t._stage}-${t.id}`} className="nbell-item nbell-item--stall" onClick={onGoToTasks}>
          <div className="nbell-item-title">{t.title} <StallBadge stall={t._stall} /></div>
          <div className="nbell-item-sub">{buildSub(t, mname)}</div>
        </button>
      ))}
    </div>
  );
}
